<mat-card>
    <mat-card-content>
        <mat-card-title>Data Pegawai</mat-card-title>
        <mat-card-subtitle>
        </mat-card-subtitle>

        <div fxLayout="row wrap" style="margin-bottom: 20px;">
            <div fxFlex.gt-lg="20" fxFlex.gt-md="20" fxFlex.gt-xs="100" fxFlex="100">
                <button *ngIf="tokenStorageService.isSuperadmin()" mat-raised-button color="primary"
                    (click)="openDialog()">
                    Tambah Pegawai
                </button>
            </div>
            <div fxFlex.gt-lg="20" fxFlex.gt-md="20" fxFlex.gt-xs="100" fxFlex="100"
                *ngIf="tokenStorageService.isSuperadmin()">
                <div class="form-group">
                    <input *ngIf="!isUploading" [formControl]="uploadFileForm" type="file" class="btn-primary"
                        multiple="multiple" (change)="selectFile($event)" accept=".xlsx" />
                </div>
            </div>
            <div fxFlex.gt-lg="20" fxFlex.gt-md="20" fxFlex.gt-xs="100" fxFlex="100"
                *ngIf="tokenStorageService.isSuperadmin()">
                <div class="form-group">
                    <input *ngIf="!isUploading" [formControl]="uploadFileForm" type="file" class="btn-primary"
                        multiple="multiple" (change)="selectFile2($event)" accept=".xlsx" />
                </div>
            </div>
            <div class="spacer"></div>
            <div fxFlex.gt-lg="20" fxFlex.gt-md="20" fxFlex.gt-xs="100" fxFlex="100">
                <input matInput placeholder="Cari..." [(ngModel)]="searchTerm" class="search-field input-outline" />
            </div>

            <button mat-raised-button color="primary" (click)="search()">
                Cari
            </button>
        </div>
        <div fxLayout="row wrap">
            <table mat-table [dataSource]="dataSource" class="full-width">
                <ng-container matColumnDef="username">
                    <th mat-header-cell *matHeaderCellDef>NIP</th>
                    <td mat-cell *matCellDef="let element" class="cell-padding">
                        {{ element.username }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef>Nama</th>
                    <td mat-cell *matCellDef="let element" class="cell-padding"><a href="#"
                            [routerLink]="['/profile-menu/' + element.id]">{{
                            element.fullname
                            }}</a></td>
                </ng-container>

                <ng-container matColumnDef="substansi">
                    <th mat-header-cell *matHeaderCellDef style="max-width: 30px; width: 30px;">Substansi</th>
                    <td mat-cell *matCellDef="let element" class="cell-padding">
                        {{ element.substansi }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="atasan">
                    <th mat-header-cell *matHeaderCellDef>Atasan Langsung</th>
                    <td mat-cell *matCellDef="let element" class="cell-padding">
                        {{ element.atasanName }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="pejabat">
                    <th mat-header-cell *matHeaderCellDef>Pejabat Berwenang Memberikan Cuti</th>
                    <td mat-cell *matCellDef="let element" class="cell-padding">
                        {{ element.pejabatName }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="role">
                    <th mat-header-cell *matHeaderCellDef>Role</th>
                    <td mat-cell *matCellDef="let element" class="cell-padding">
                        {{ displayUserRoles(element) }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef>Status</th>
                    <td mat-cell *matCellDef="let element" class="cell-padding">
                        {{ element.enabled === 1 ? 'AKTIF' : 'NON-AKTIF' }}
                    </td>
                </ng-container>

                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef>Aksi</th>
                    <td mat-cell *matCellDef="let element">
                        <!-- <button mat-icon-button [routerLink]="['/profile/' + element.id]" matTooltip="Profile"
                      matTooltipPosition="above">
                      <mat-icon>edit</mat-icon>
                    </button> -->
                        <button *ngIf="tokenStorageService.isSuperadmin()" mat-icon-button class="action-button"
                            (click)="openDialog(element)" matTooltip="Ubah User" matTooltipPosition="above">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button *ngIf="tokenStorageService.isSuperadmin() || tokenStorageService.isAdminKepegawaian()"
                            mat-icon-button class="action-button" (click)="openHakCutiDialog(element)"
                            matTooltip="Update Hak Cuti" matTooltipPosition="above">
                            <mat-icon>assignment</mat-icon>
                        </button>
                        <!-- <button mat-icon-button class="action-button" matTooltip="Hierarki User" matTooltipPosition="above"
                      (click)="openHierarchyDialog(element)">
                      <mat-icon>account_tree</mat-icon>
                    </button> -->
                        <button *ngIf="tokenStorageService.isSuperadmin()" mat-icon-button class="action-button"
                            (click)="confirmDialog(element)" matTooltip="Hapus User" matTooltipPosition="above">
                            <mat-icon>delete</mat-icon>
                        </button>
                        <button *ngIf="tokenStorageService.isSuperadmin() || tokenStorageService.isAdminKepegawaian()"
                            mat-icon-button class="action-button" (click)="confirmResetDialog(element)"
                            matTooltip="Reset Password Default" matTooltipPosition="above">
                            <mat-icon>lock_reset</mat-icon>
                        </button>
                        <button *ngIf="tokenStorageService.isSuperadmin()" mat-icon-button class="action-button"
                            (click)="confirmActivationDialog(element)"
                            [matTooltip]="element.enabled === 1 ? 'Non-Aktifkan' : 'Aktifkan'"
                            matTooltipPosition="above">
                            <mat-icon>{{
                                element.enabled === 1
                                ? 'do_not_disturb_alt'
                                : 'check_circle_outline'
                                }}</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
            <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
        </div>
        <div fxLayout="row wrap">
            <mat-paginator #paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                (page)="reload($event)">
            </mat-paginator>
        </div>
    </mat-card-content>
</mat-card>